import { Image } from "antd";
import { Fragment, h } from "preact";
import { useEffect, useState } from "preact/hooks";

interface IImage {
  imageId: string
  url: string
  imageType: string
  createDate: string
}
interface IShowImage {
  onPress?(): Promise<void> | boolean | void | undefined;
  visible: boolean;
  image: IImage[];
}

export const ShowImage = ({ visible, image = [], onPress }: IShowImage) => {
  const [images, setImages] = useState(image);

  useEffect(() => {
    setImages(image)
  }, [image])

  return images.map((e) => <Image
    key={e.imageId}
    width={200}
    src={e.url}
  />)
};
